export default __webpack_public_path__ + "static/media/MarsCentra-Bold.e3aa594f.svg";